import {Component, OnDestroy, OnInit} from "@angular/core";
import {Subscription} from "rxjs";
import {UtilsService} from "../../../../core/utils/utils.service";
import {Auth2Service} from "../../../../core/services/security/auth2.service";
import {RoutemapService} from "../../../../core/services/routemap.service";
import {GenericManageDialogService} from "../../../../core/services/generics/generic-manage-dialog.service";
import {GenericDatagridService} from "../../../../core/services/generics/generic-datagrid.service";
import {DialogMsgSupplier, Paragraphe} from "../../../../core/suppliers/dialog-msg-supplier";
import {TypeTachePmsDto} from "../../../../core/dtos/pms/type-tache-pms-dto";
import {TypeTachePmsSavedSupplier, TypeTachePmsService} from "../../../../core/services/pms/type-tache-pms.service";
import {InternationalizationService} from "../../../../core/services/i8n/i8n.service";
import {HELP_FOLDERS, MSG_KEY, MSG_SEVERITY} from "../../../../core/constants";
import {Title} from "@angular/platform-browser";
import {confirm} from "devextreme/ui/dialog";
import {ToastService} from "../../../../core/services/technique/toast.service";

@Component({
  selector: 'yo-pms-type-tache-grille',
  templateUrl: './pms-type-tache-grille.component.html',
  styleUrls: ['./pms-type-tache-grille.component.scss']
})
export class PmsTypeTacheGrilleComponent implements OnInit, OnDestroy {
  typesTacheList: TypeTachePmsDto[] = [];

  hasPms = false;

  subTypeTacheSaved: Subscription;

  allMode: string;
  checkBoxesMode: string;
  selectedRows: number[] = [];

  pathFile: string = HELP_FOLDERS.PMS + '/pms-types-taches';

  constructor(public utils: UtilsService,
              private auth2Svc: Auth2Service,
              private routeMapSvc: RoutemapService,
              private genericManageDialogService: GenericManageDialogService,
              public gds: GenericDatagridService,
              private i8nSvc: InternationalizationService,
              private typeTachePmsService: TypeTachePmsService,
              private title: Title,
              private toastSvc: ToastService) {}

  ngOnInit(): void {
    this.initHasPms();
    this.initTypesTachePms();
    this.typeTacheSavedSubscription();
    this.initProperty();
  }

  initProperty = (): void => {
    this.allMode = 'allPages';
    this.checkBoxesMode = 'always';
    this.title.setTitle(this.getTitle());
  };

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subTypeTacheSaved);
  }

  getTitle = (): string => "GESTION DES TYPES DE TÂCHE";

  canEdit = (): boolean => this.hasPms && this.auth2Svc.hasSitesLocaux();

  initTypesTachePms = (): void => {
    this.typeTachePmsService.getAll()
      .subscribe(response => {
        this.typesTacheList = response.resultList;
      });
  };

  initHasPms = (): void => {
    this.auth2Svc.hasPms$.subscribe(response => this.hasPms = response);
  };

  typeTacheSavedSubscription = (): void => {
    this.subTypeTacheSaved = this.typeTachePmsService.typeTacheSaved$
      .subscribe((response: TypeTachePmsSavedSupplier) => {
        if (!response.isUpdate) {
          this.typesTacheList.push(response.typeTache);
        }
      });
  };

  openTypeTache = (t: TypeTachePmsDto): void => {
    this.typeTachePmsService.announceOpenDialog(t);
  };

  deleteValues = async (): Promise<void> => {
    const result = confirm('Êtes-vous sûr de vouloir supprimer le(s) élément(s) sélectionnés ?', 'Confirmation');
    const isDeleted: boolean = await result;
    if (isDeleted) {
      const idsToDelete: number[] = this.selectedRows
        .map((idSelected: number) => this.typesTacheList.find(t => t.id === idSelected))
        .map((type: TypeTachePmsDto) => type.id);
      this.typeTachePmsService.deleteByIds(idsToDelete)
        .subscribe(o => {
          this.typesTacheList = this.utils.handleIsDeletableResultWithNum(o.one, idsToDelete, this.typesTacheList)
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `La suppression a été réalisée avec succès`);
        });
    }
  };

  public help = (): DialogMsgSupplier => {
    const dms = new DialogMsgSupplier();
    dms.title = `Les types de tâche PMS (Plan de Mesure Sanitaire)`;
    dms.logo = 'fa fa-question-circle  yoni-color';
    const p1: Paragraphe = new Paragraphe();
    p1.title = ``;
    p1.lines = [
    ];

    dms.content = {
      intro: ``,
      paragraphes: []
    };

    return dms;
  };
}
